import api from '@/api'

const SET_REPORTS = 'SET_REPORTS'
const SET_FILTERS = 'SET_FILTERS'
const SET_TOTAL_COUNT = 'SET_TOTAL_COUNT'
export default {
  namespaced: true,

  state () {
    return {
      reports: [],
      filters: null,
      totalCount: 0,
    }
  },

  getters: {
    filters: (state) => state.filters || {},
    reports: (state) => state.reports,
    totalCount: (state) => state.totalCount
  },

  mutations: {
    [SET_REPORTS] (state, data) {
      state.reports = data
    },

    [SET_FILTERS] (state, data) {
      state.filters = data
    },
    [SET_TOTAL_COUNT] (state, count) {
      state.totalCount = count
    }
  },

  actions: {
    async loadReports (context, filters = {}) {
      // context.commit(SET_FILTERS, filters)
      const params = {}
      params.farm = filters.farm
      params.planned_on_after = filters.planned_on_after.substring(0, 10)
      params.planned_on_before = filters.planned_on_before.substring(0, 10)
      if (filters.status && filters.status.length) {
        params.status = filters.status.join(',')
      }
      if (filters.animalfeed_recipe && filters.animalfeed_recipe.length) {
        params.animalfeed_recipe = filters.animalfeed_recipe.join(',')
      }
      if (filters.loaded_time_min) {
        params.loaded_time_min = filters.loaded_time_min
      }
      if (filters.loaded_time_max) {
        params.loaded_time_max = filters.loaded_time_max
      }
      const { data, count } = await api.reports.animalfeed.list(params)
      context.commit(SET_TOTAL_COUNT, count)
      context.commit(SET_REPORTS, data || [])
    },
    applyFilters ({ commit }, params = {}) {
      commit(SET_FILTERS, params)
    },

    async makeReport ({ state }) {
      const filters = {
        report: 'animalfeed_schedule_load'
      }
      for (const key in state.filters) {
        filters[key] = state.filters[key]
      }
      if (filters.planned_on_after) {
        filters.planned_on_after = filters.planned_on_after.substring(0, 10)
      }
      if (filters.planned_on_before) {
        filters.planned_on_before = filters.planned_on_before.substring(0, 10)
      }
      if (filters.status && filters.status.length) {
        filters.status = filters.status.join(',')
      }
      if (filters.animalfeed_recipe && filters.animalfeed_recipe.length) {
        filters.animalfeed_recipe = filters.animalfeed_recipe.join(',')
      }
      const { data } = await api.reports.make('animalfeed/dashboard', filters)
      return data
    }
  }
}
